import gql from 'graphql-tag';

export default gql`
    query GetAllEquipmentTypes {
        getAllEquipmentTypes {
            id
            name
        }
    }
`;
